import { memo, FC } from 'react'
import {
  SimpleGrid,
  useDisclosure,
  Box,
  Center,
  Tooltip,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
} from '@chakra-ui/react'

import { COLORS } from 'constants/variables'

type Props = {
  color?: string
  setColor: (newColor: string) => void
}

const CustomColorPicker: FC<Props> = ({ color, setColor }) => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  function onSelect(color: string) {
    setColor(color)
    onClose()
  }

  return (
    <>
      <Popover placement="bottom-start" isOpen={isOpen} onOpen={onOpen} onClose={onClose} closeOnBlur={false}>
        <PopoverTrigger>
          <Box>
            <Tooltip label="Você pode selecionar uma cor">
              <Box
                className="accessible"
                minHeight="30px"
                minWidth="30px"
                rounded="full"
                bg={color ? `${color}.500` || 'gray.500' : 'gray.500'}
                borderWidth="2px"
                borderColor="transparent"
                _hover={{ borderColor: 'primary' }}
              />
            </Tooltip>
          </Box>
        </PopoverTrigger>

        <PopoverContent shadow="lg">
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverHeader>Selecione uma cor</PopoverHeader>
          <PopoverBody>
            <SimpleGrid columns={5} gap={4}>
              {COLORS.map((colorItem) => (
                <Center
                  key={colorItem}
                  className="accessible"
                  p={1}
                  height="40px"
                  width="40px"
                  rounded="full"
                  borderWidth="4px"
                  borderColor={color === colorItem ? 'primary' : 'transparent'}
                  _hover={{ borderColor: 'primary' }}
                  onClick={() => onSelect(colorItem)}
                >
                  <Box minHeight="30px" minWidth="30px" rounded="full" bg={`${colorItem}.500`} />
                </Center>
              ))}
            </SimpleGrid>
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </>
  )
}

export default memo(CustomColorPicker)
